import React from 'react';
import AppButton, { type AppButtonProps } from './AppButton';

type TableAction = 'edit' | 'delete' | 'detail';

export interface AppTableActionButtonProps extends AppButtonProps {
  action: TableAction;
}

const actionClassNames: Record<TableAction, string> = {
  edit: 'text-green-700 bg-green-100 hover:bg-green-200 hover:!text-green-800',
  delete: 'text-red-700 bg-red-100 hover:bg-red-200 hover:!text-red-700',
  detail: 'text-blue-700 bg-blue-100 hover:bg-blue-200 hover:!text-blue-800',
};

const actionIcons: Record<TableAction, React.ReactNode> = {
  edit: <i className="fa fa-pencil" aria-hidden="true" />,
  delete: <i className="fa fa-trash-o" aria-hidden="true" />,
  detail: <i className="fa fa-info" aria-hidden="true" />,
};

const AppTableActionButton = React.forwardRef<HTMLButtonElement, AppTableActionButtonProps>(
  ({ action, className = '', type = 'default', icon, ...props }, ref) => (
    <AppButton
      ref={ref}
      type={type}
      icon={icon ?? actionIcons[action]}
      className={`text-xs font-medium !border-0 ${actionClassNames[action]} ${className}`}
      {...props}
    />
  )
);

AppTableActionButton.displayName = 'AppTableActionButton';

export default AppTableActionButton;
